import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SentimentVerySatisfiedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sentiment_very_satisfied"}/>
}
